import { render, staticRenderFns } from "./FscCardTable.vue?vue&type=template&id=7da38208&"
import script from "./FscCardTable.vue?vue&type=script&lang=ts&"
export * from "./FscCardTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports